/**
 * IntelliGems A/B Test: PDP mobile left-align
 *
 * Control (A): data-pdp-left-align="false"
 * Variant (B): data-pdp-left-align="true"
 *
 * Dev preview: ?pdp_left_align_test=b
 *
 * Mobile only. Left-aligns PDP copy and the icon/text row
 * sitting just below the product image.
 */
(function () {
  'use strict';

  if (window.__pdpLeftAlignABTestInit) return;
  window.__pdpLeftAlignABTestInit = true;

  var BODY_ATTR = 'data-pdp-left-align';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('pdp_left_align_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) return;

      variantActive = variantB;
      document.documentElement.classList.toggle('pdp-left-align-b', variantB);
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  window.PdpLeftAlignABTest = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      variantActive = null;
      applyVariant();
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      variantActive = null;
      applyVariant();
    },
    isActive: isVariantB
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
